<template>
  <div>
    <CheckList />
  </div>
</template>

<script>
import CheckList from '../components/CheckList.vue';

export default {
  name: 'chequesBeta',
  components: {
    CheckList
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/chequesBeta.vue